import React from "react";
import { IResourceComponentsProps, usePermissions } from "@pankod/refine-core";
import {
  Edit,
  Form,
  Input,
  useForm,
  Select,
  Row,
  Col,
} from "@pankod/refine-antd";
import {
  IoNotifications,
  IoMail,
  IoCalendar,
  IoAlertCircle,
  IoInformationCircle,
  IoWarning,
  IoCheckmarkCircle,
  IoCloseCircle,
  IoDocumentText,
  IoFolder,
  IoHome,
  IoPerson,
  IoSchool,
  IoBook,
  IoNewspaper,
  IoMegaphone,
  IoTrophy,
  IoStar,
  IoHeart,
  IoGift,
} from "react-icons/io5";

import "react-mde/lib/styles/css/react-mde-all.css";

import { IMessageType } from "interfaces/message-type.interface";

// Helper para renderizar iconos correctamente
const IconWrapper = ({ Icon, size = 20 }: { Icon: any; size?: number }) => {
  return <Icon size={size} />;
};

// Lista de iconos Ionicons (compatible con Expo @expo/vector-icons)
// Los valores se guardan en formato Expo para usar directamente en la app móvil
const iconOptions = [
  { value: "notifications", label: "Notificaciones", IconComponent: IoNotifications },
  { value: "mail", label: "Correo", IconComponent: IoMail },
  { value: "calendar", label: "Calendario", IconComponent: IoCalendar },
  { value: "alert-circle", label: "Alerta", IconComponent: IoAlertCircle },
  { value: "information-circle", label: "Información", IconComponent: IoInformationCircle },
  { value: "warning", label: "Advertencia", IconComponent: IoWarning },
  { value: "checkmark-circle", label: "Verificado", IconComponent: IoCheckmarkCircle },
  { value: "close-circle", label: "Cerrar", IconComponent: IoCloseCircle },
  { value: "document-text", label: "Documento", IconComponent: IoDocumentText },
  { value: "folder", label: "Carpeta", IconComponent: IoFolder },
  { value: "home", label: "Inicio", IconComponent: IoHome },
  { value: "person", label: "Persona", IconComponent: IoPerson },
  { value: "school", label: "Escuela", IconComponent: IoSchool },
  { value: "book", label: "Libro", IconComponent: IoBook },
  { value: "newspaper", label: "Noticias", IconComponent: IoNewspaper },
  { value: "megaphone", label: "Megáfono", IconComponent: IoMegaphone },
  { value: "trophy", label: "Trofeo", IconComponent: IoTrophy },
  { value: "star", label: "Estrella", IconComponent: IoStar },
  { value: "heart", label: "Corazón", IconComponent: IoHeart },
  { value: "gift", label: "Regalo", IconComponent: IoGift },
];

export const MessageTypeEdit: React.FC<IResourceComponentsProps> = () => {

  const { formProps, saveButtonProps, queryResult } = useForm<IMessageType>();

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Tipo"
          name="type"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              label="Icono"
              name="icon"
              tooltip="Selecciona un icono para representar este tipo de mensaje"
            >
              <Select placeholder="Selecciona un icono">
                {iconOptions.map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <IconWrapper Icon={option.IconComponent} size={20} />
                      <span>{option.label}</span>
                    </div>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Color del Icono"
              name="icon_color"
              tooltip="Selecciona el color del icono"
            >
              <Input type="color" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Color de Fondo"
              name="icon_background_color"
              tooltip="Selecciona el color de fondo del icono"
            >
              <Input type="color" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Edit>
  );
};
